// src/app/hooks/usePageLifecycle.tsx
'use client'; // 确保这是一个客户端 Hook

import { useState, useEffect } from 'react';

const usePageLifecycle = (onEnter?: () => void, onLeave?: () => void) => {
    const [isVisible, setIsVisible] = useState<boolean>(false); // 初始值设为 false

    useEffect(() => {
        // 确保在客户端执行
        if (typeof document !== 'undefined') {
            // 初始化状态
            setIsVisible(document.visibilityState === 'visible');

            const handleVisibilityChange = () => {
                if (document.visibilityState === 'visible') {
                    setIsVisible(true);
                    if (onEnter) onEnter();
                } else {
                    setIsVisible(false);
                    if (onLeave) onLeave();
                }
            };

            document.addEventListener('visibilitychange', handleVisibilityChange);

            return () => {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            };
        }
    }, [onEnter, onLeave]);

    return isVisible;
};

export default usePageLifecycle;
